const sampleSchemes = {
  'English|pre-primary': {
    rows: [
      ['Skills Developed', 'Alphabet Knowledge', 'Vocabulary Building', 'Spelling Skills', 'Rhyming Skills', 'Body Awareness & Spelling', 'Expression through Rhymes', 'Creative Thinking', 'Curiosity & Interaction'],
      ['Question Type', 'Alphabets A–Z', 'Say 2-letter & 3-letter words', 'Spell 3-letter words', 'Say rhyming words', 'Name & spell 5 body parts', 'Sing any rhyme', 'Tell a story', 'Ask 2 questions & interact'],
      ['Question Example', 'A, B, C... Z', 'it, an, on, sun, cat, bat', 'Spell: dog, pen, cup', 'rhymes with "hat"?', 'Eyes, nose, ear, leg, hand', 'Twinkle Twinkle', 'Once upon a time...', 'Why is the sky blue? etc.'],
      ['Max Marks', '5', '5', '5', '5', '5', '5', '5', '5']
    ],
    cellStyle: { padding: '12px 16px', border: '1px solid #f3e2b7', minWidth: 120 },
    tableStyle: { borderCollapse: 'separate', borderSpacing: '0 8px', fontSize: '0.93em', border: 'none' }
  },
  'Mathematics|pre-primary': {
    rows: [
      ['Skills Developed', 'Number Sense', 'Reverse Thinking', 'Sequencing', 'Pattern Recognition', 'Addition Skills', 'Logical Thinking', 'Shape Awareness', 'Curiosity'],
      ['Question Type', 'Forward Count', 'Reverse Count', 'Say in Order', 'Skip 2s, 5s', 'Simple Addition', 'Simple Subtraction', 'Identify Shapes', 'Ask / Interact'],
      ['Question Example', '1, 2, 3...', '10, 9, 8...', '3, 4, 5...', '2, 4, 6...', '2 + 1 = ?', '5 – 3 = ?', 'Shape of Door, Bread...', 'Can I count the stars?'],
      ['Max Marks', '5', '5', '5', '5', '5', '5', '5', '5']
    ],
    cellStyle: { padding: '10px 12px', border: '1px solid #222', minWidth: 100 },
    tableStyle: { borderCollapse: 'collapse', fontSize: '0.93em', border: '2px solid #222' }
  },
  
};

export default sampleSchemes;
